'use strict';

var React = require('react');

var SvgDiscountCodeMajor = function SvgDiscountCodeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 3h-1v1h-2v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5v2zm5 0h-3v-2h3v2zm5 0h-3v-2h3v2zm-13 6v-3h2v3h-2zm0 2v3h2v-3h-2zm16-5h2v3h-2v-3zm2 5h-2v3h2v-3zm-10 8v-2h-3v2h3zm5-2v2h-3v-2h3zm-5-9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm3.5 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1.207-7.707a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0zm4.293 12.707a1 1 0 0 0 1-1v-2h-2v1h-1v2h2zm-16 0a1 1 0 0 1-1-1v-2h2v1h1v2h-2zm15-15v-1h-1v-2h1.5a1.5 1.5 0 0 1 1.5 1.5v1.5h-2z"
  }));
};

exports.SvgDiscountCodeMajor = SvgDiscountCodeMajor;
